import React from "react";
import { Outlet, useLoaderData } from "react-router-dom";
import TabLayout from "../../../helpers/TabLayout";

const UserLayout = () => {
  const { user } = useLoaderData();
  const headerLabel = `${user.firstName || ""} ${(user.lastName) ?? ""}`;
  return (
    <>
      <TabLayout
        headerLabel={headerLabel.trim() || "User"}
        skeletonLines={14}
      >
        <Outlet/>
      </TabLayout>
    </>
  );
};

export default UserLayout;